import Select1 from "./v-select1.vue";

/* istanbul ignore next */
Select1.install = function(Vue) {
  Vue.component(Select1.name, Select1);
};

export default Select1;
